import { AREA, BAR, COLUMN, GAUGE, LINE } from 'reporting-data/constants/chartTypes';
import { getReportChartType } from 'reporting-data/report/reportGetters';
import { isConfigReport, isMultiConfigReport, isRelationalReport } from 'reporting-data/tsTypes/reportTypes';
import { VisualTypes } from 'reporting-snowflake/relational/schema/visual-records';
import { createRelationalReportFromBaseReport } from 'reporting-snowflake/relational/utils/report-utils';
import { getReportVisualType } from 'reporting-snowflake/relational/utils/report-utils';
export const shouldHideNoneOption = ({
  report,
  minDimensions,
  hideClearButton
}) => {
  if (hideClearButton || minDimensions >= 1) {
    return true;
  }
  if (isConfigReport(report)) {
    const chartType = getReportChartType(report);
    return [LINE, AREA, COLUMN, BAR, GAUGE].includes(chartType || '') || isMultiConfigReport(report);
  }
  if (isRelationalReport(report)) {
    const relationalReport = createRelationalReportFromBaseReport(report);
    const chartType = getReportVisualType(relationalReport);
    return chartType && [VisualTypes.LINE, VisualTypes.AREA, VisualTypes.VERTICAL_BAR, VisualTypes.HORIZONTAL_BAR, VisualTypes.GAUGE].includes(chartType);
  }
  return false;
};
export const RESTRICTED_RELATIONAL_REPORT_VISUAL_TYPES = [VisualTypes.COMBO, VisualTypes.TEXT, VisualTypes.GAUGE, VisualTypes.PIVOT_TABLE];
export const isAllowableChartTypeForRelationalEditing = report => {
  const relationalReport = createRelationalReportFromBaseReport(report);
  const visualType = getReportVisualType(relationalReport);
  return visualType !== null && !RESTRICTED_RELATIONAL_REPORT_VISUAL_TYPES.includes(visualType);
};